import { useQuery } from 'react-query';

import getScanSelfServiceAutosuggestions from '@/ebat/api/scan-self-service/getScanSelfServiceAutosuggestions';

const getEmptyData = () => new Promise((resolve) => resolve([]));

const useScanSelfServiceAutosuggestions = (
  [endpoint, autosuggestionTerm],
  disabled,
  minSearchTermLength,
) => {
  const queryFn =
    autosuggestionTerm.trim().length < minSearchTermLength
      ? getEmptyData
      : getScanSelfServiceAutosuggestions;
  return useQuery([endpoint, autosuggestionTerm], queryFn, {
    keepPreviousData: true,
    enabled: !disabled,
    select: (response) => response?.data ?? [],
  });
};

export default useScanSelfServiceAutosuggestions;
